import { Animated, Easing } from 'react-native';

export const createFadeInAnimation = (
  animatedValue: Animated.Value,
  duration: number = 300,
  delay: number = 0
) => {
  return Animated.timing(animatedValue, {
    toValue: 1,
    duration,
    delay,
    easing: Easing.out(Easing.cubic),
    useNativeDriver: true,
  });
};

export const createSlideInAnimation = (
  animatedValue: Animated.Value,
  fromValue: number = 50,
  duration: number = 400,
  delay: number = 0
) => {
  animatedValue.setValue(fromValue);
  return Animated.timing(animatedValue, {
    toValue: 0,
    duration,
    delay,
    easing: Easing.out(Easing.cubic),
    useNativeDriver: true,
  });
};

export const createScaleAnimation = (
  animatedValue: Animated.Value,
  fromValue: number = 0.8,
  toValue: number = 1,
  duration: number = 300,
  delay: number = 0
) => {
  animatedValue.setValue(fromValue);
  return Animated.spring(animatedValue, {
    toValue,
    tension: 100,
    friction: 8,
    delay,
    useNativeDriver: true,
  });
};

export const createPressAnimation = (
  animatedValue: Animated.Value,
  pressedScale: number = 0.95,
  duration: number = 100
) => {
  const pressIn = () => {
    Animated.timing(animatedValue, {
      toValue: pressedScale,
      duration,
      useNativeDriver: true,
    }).start();
  };

  const pressOut = () => {
    Animated.spring(animatedValue, {
      toValue: 1,
      tension: 150,
      friction: 8,
      useNativeDriver: true,
    }).start();
  };

  return { pressIn, pressOut };
};

export const createShimmerAnimation = (animatedValue: Animated.Value) => {
  const shimmer = () => {
    animatedValue.setValue(0);
    Animated.loop(
      Animated.timing(animatedValue, {
        toValue: 1,
        duration: 1500,
        easing: Easing.linear,
        useNativeDriver: true,
      })
    ).start();
  };

  return shimmer;
};

export const staggeredFadeIn = (
  animations: Animated.Value[],
  duration: number = 300,
  stagger: number = 100
) => {
  const animationSequence = animations.map((anim, index) =>
    createFadeInAnimation(anim, duration, index * stagger)
  );

  return Animated.parallel(animationSequence);
};